/** Shared backdrop + paper styles for app modals (match logout confirmation). */

export const MODAL_BACKDROP_SX = {
    backgroundColor: "var(--primary-popup-overlay-bg)",
    backdropFilter: "var(--primary-popup-overlay-blur)",
};

/** Use on MUI Modal / Dialog `BackdropProps` (preferred in this project). */
export const modalBackdropProps = {
    sx: MODAL_BACKDROP_SX,
};

/** Use on MUI Modal `slotProps` when running a newer MUI that supports it. */
export const modalSlotProps = {
    backdrop: {
        sx: MODAL_BACKDROP_SX,
    },
};

export const MODAL_PAPER_SX = {
    bgcolor: "var(--primary-popup-background-color)",
    color: "var(--primary-text-color)",
    border: "3px solid var(--primary-popup-stroke-color)",
    borderRadius: "16px",
    outline: "none",
};

/** Centered modal panel; pass width/height/padding overrides as needed. */
export const centeredModalBoxSx = (overrides = {}) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "100%",
    maxHeight: "calc(100vh - 48px)",
    overflow: "auto",
    ...MODAL_PAPER_SX,
    ...overrides,
});
